import { render, staticRenderFns } from "./waitlist.vue?vue&type=template&id=145df50a&"
import script from "./waitlist.vue?vue&type=script&lang=js&"
export * from "./waitlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports